import React, { useContext, useEffect, useRef, useState } from 'react';
import { AdminContext } from '../../context/AdminContext';
import AppIcons from '../../icons';
import styles from './styles.module.css';

const UserMoreBox = ({ user, setopenBox, openBox, content, clickItem }) => {
  const {
    direction,
    openCreateGroup,
    setOpenCreateGroup,
    activeUser,
    setGroupState,
  } = useContext(AdminContext);
  const ref = useRef();
  const clickFunction = (id) => {
    if (id == openBox) {
      setopenBox();
    } else {
      setopenBox(id);
    }
  };
  const checkIfClickedOutside = (e) => {
    // If the menu is open and the clicked target is not within the menu,
    // then close the menu
    if (openBox && ref.current && !ref.current.contains(e.target)) {
      setopenBox(false);
      console.log('firstdepen');
    }
  };
  useEffect(() => {
    document.addEventListener('mousedown', checkIfClickedOutside);

    return () => {
      // Cleanup the event listener
      document.removeEventListener('mousedown', checkIfClickedOutside);
    };
  }, [openBox]);

  useEffect(() => {}, [direction, user]);
  console.log('open', openBox, user);
  return (
    <>
      <AppIcons.MoreIcon
        style={{ margin: `0 5px` }}
        onClick={(e) => {
          e.stopPropagation();
          e.preventDefault();
          clickFunction(user?.users?.[0]?.channelUser?.uuid);
        }}
      />
      {openBox == user?.users?.[0]?.channelUser?.uuid && (
        <div
          className={`${styles.settingBox} ${
            direction == 'ltr' && styles.settingBoxRight
          } themeBox `}
          ref={ref}
        >
          {content?.chatBar?.userMore?.map((item, index) => (
            <div
              className={`flex flex-row justify-between items-center w-full h-auto`}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                clickItem(item, user);
              }}
              key={index}
            >
              {item?.id == 1 && (
                <>
                  <p className={`preserveStyle`}>
                    {user?.pin == 1 ? item?.notChosen : item?.chosen}
                  </p>
                  <div className={`flex flex-row justify-center items-center`}>
                    {item?.icon}
                  </div>
                </>
              )}
              {item?.id == 2 && (
                <>
                  {user?.typeId != 2 && (
                    <>
                      <p className={`preserveStyle`}>{item?.chosen}</p>
                      <div
                        className={`flex flex-row justify-center items-center`}
                      >
                        {item?.icon}
                      </div>
                    </>
                  )}
                  {user?.typeId == 2 && user?.users?.[0]?.levelManage == 1 && (
                    <>
                      <p className={`preserveStyle`}>{item?.chosen}</p>
                      <div
                        className={`flex flex-row justify-center items-center`}
                      >
                        {item?.icon}
                      </div>
                    </>
                  )}
                </>
              )}
              {item?.id == 8 && (
                <>
                  <p className={`preserveStyle`}>
                    {user?.mute == 1 ? item?.notChosen : item?.chosen}
                  </p>
                  <div className={`flex flex-row justify-center items-center`}>
                    {user?.mute == 1 ? item?.notchosenIcon : item?.icon}
                  </div>
                </>
              )}
              {item?.id == 3 && user?.typeId != 2 && (
                <>
                  <p className={`preserveStyle`}>
                    {user?.block == 1 ? item?.notChosen : item?.chosen}
                  </p>
                  <div className={`flex flex-row justify-center items-center`}>
                    {item?.icon}
                  </div>
                </>
              )}
              {item?.id == 4 &&
                user?.typeId == 2 &&
                user?.users?.[0]?.levelManage != 0 && (
                  <div
                    className={`flex flex-row justify-between items-center w-full j-auto`}
                    // onClick={() => {
                    //   setOpenCreateGroup(true);
                    //   setGroupState(activeUser);
                    // }}
                  >
                    <p className={`preserveStyle`}>{item?.chosen}</p>
                    <div
                      className={`flex flex-row justify-center items-center`}
                    >
                      {item?.icon}
                    </div>
                  </div>
                )}
              {item?.id == 5 &&
                user?.typeId == 2 &&
                user?.users?.[0]?.levelManage == 0 && (
                  <div
                    className={`flex flex-row justify-between items-center w-full j-auto`}
                    // onClick={() => {
                    //   setOpenCreateGroup(true);
                    //   setGroupState(activeUser);
                    // }}
                  >
                    <p className={`preserveStyle`}>{item?.chosen}</p>
                    <div
                      className={`flex flex-row justify-center items-center`}
                    >
                      {item?.icon}
                    </div>
                  </div>
                )}
              {item?.id == 6 && user?.typeId == 2 && (
                <div
                  className={`flex flex-row justify-between items-center w-full j-auto`}
                  // onClick={() => {
                  //   setOpenCreateGroup(true);
                  //   setGroupState(activeUser);
                  // }}
                >
                  <p className={`preserveStyle`}>{item?.chosen}</p>
                  <div className={`flex flex-row justify-center items-center`}>
                    {item?.icon}
                  </div>
                </div>
              )}
              {item?.id == 7 && user?.typeId == 2 && (
                <div
                  className={`flex flex-row justify-between items-center w-full j-auto`}
                  // onClick={() => {
                  //   setOpenCreateGroup(true);
                  //   setGroupState(activeUser);
                  // }}
                >
                  <p className={`preserveStyle`}>{item?.chosen}</p>
                  <div className={`flex flex-row justify-center items-center`}>
                    {item?.icon}
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </>
  );
};
export default UserMoreBox;
